

import React, { useState, useEffect, useRef } from 'react';

const testimonials = [
  {
    text: "Since implementing this platform, I've cut my admin time by 35%. Now I can focus on what I do best—helping my clients achieve their goals.",
    author: "Rachel K.",
    role: "Life Coach",
    avatar: "/avatar1.png"
  },
  {
    text: "My clients love the sleek app interface. Several have mentioned how easy it is to track progress, schedule sessions, and communicate with me all in one place.",
    author: "Marco T.",
    role: "Business Coach",
    avatar: "/avatar2.png"
  },
  {
    text: "Client retention has never been better. The automated check-ins keep them engaged between sessions, and I've seen a 40% increase in renewals.",
    author: "Vivian L.",
    role: "Executive Coach",
    avatar: "/avatar3.png"
  },
  {
    text: "The time I used to spend on scheduling and paperwork has been cut in half. My clients get faster responses, and I get to focus on delivering value.",
    author: "Sean R.",
    role: "Fitness Coach",
    avatar: "/avatar4.png"
  },
  {
    text: "As a nutrition coach with dozens of clients, the automated meal tracking and progress updates have been game-changing. My clients stay consistent, and I save hours each week.",
    author: "Kim W.",
    role: "Nutrition Coach",
    avatar: "/avatar5.png"
  },
  {
    text: "The intuitive client portal has completely transformed my practice. My clients are more engaged, and I've reduced my admin workload by nearly 30%.",
    author: "Amina B.",
    role: "Career Coach",
    avatar: "/avatar6.png"
  },
  {
    text: "Managing client data, progress tracking, and communication used to eat up my evenings. Now it's all streamlined, and I've reclaimed 10+ hours every week.",
    author: "Peter S.",
    role: "Health Coach",
    avatar: "/avatar1.png"
  },
  {
    text: "My clients rave about the app experience. The easy scheduling and progress visualization keep them motivated, and my renewal rate has never been higher.",
    author: "Joanne G.",
    role: "Mindfulness Coach",
    avatar: "/avatar2.png"
  },
  {
    text: "From payment processing to program delivery, everything is seamless. I've been able to scale my coaching business without the typical administrative headaches.",
    author: "Carlos M.",
    role: "Performance Coach",
    avatar: "/avatar3.png"
  }
];

const Testimonials = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const scrollRef = useRef(null);
  
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    let animationFrameId;
    let scrolling = true;
    
    const scroll = () => {
      if (!scrollContainer || !scrolling) return;
      
      setScrollPosition(prev => {
        const newPosition = prev + 0.5;
        if (newPosition >= scrollContainer.scrollWidth - scrollContainer.clientWidth) {
          return 0; // Reset to start
        }
        return newPosition;
      });
      
      scrollContainer.scrollLeft = scrollPosition;
      animationFrameId = requestAnimationFrame(scroll);
    };

    animationFrameId = requestAnimationFrame(scroll);
    
    const handleMouseEnter = () => {
      scrolling = false;
    };

    const handleMouseLeave = () => {
      scrolling = true;
      requestAnimationFrame(scroll);
    };

    scrollContainer.addEventListener('mouseenter', handleMouseEnter);
    scrollContainer.addEventListener('mouseleave', handleMouseLeave);
    
    return () => {
      cancelAnimationFrame(animationFrameId);
      if (scrollContainer) {
        scrollContainer.removeEventListener('mouseenter', handleMouseEnter);
        scrollContainer.removeEventListener('mouseleave', handleMouseLeave);
      }
    };
  }, [scrollPosition]);

  return (
    <section id="testimonials" className="py-16 sm:py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-center mb-2">
          <span className="text-3xl">⏱️</span>
        </div>
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-4">
          Coaches Save Time, Clients Stay Longer
        </h2>
        <p className="text-lg text-center text-gray-600 mb-12">
          See how coaches are cutting admin work by 30% while boosting client satisfaction
        </p>

        <div className="relative overflow-hidden">
          {/* Scrolling Container */}
          <div 
            ref={scrollRef}
            className="flex gap-4 sm:gap-6 whitespace-nowrap overflow-x-hidden"
          >
            {[...testimonials, ...testimonials].map((testimonial, index) => (
              <div 
                key={index}
                className="inline-flex flex-none w-[280px] sm:w-[350px] bg-white rounded-2xl p-4 sm:p-6 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1"
              >
                <div className="overflow-hidden">
                  <p className="text-gray-800 mb-4 sm:mb-6 text-sm sm:text-base leading-relaxed whitespace-normal">
                    "{testimonial.text}"
                  </p>
                  <div className="flex items-center gap-3">
                    {/* <div className="w-8 h-8 bg-gray-200 rounded-full overflow-hidden">
                    </div> */}
                    <div>
                      <p className="font-medium text-sm sm:text-base">{testimonial.author}</p>
                      <p className="text-gray-500 text-xs sm:text-sm">{testimonial.role}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="absolute left-0 top-0 bottom-0 w-12 sm:w-20 bg-gradient-to-r from-gray-50 to-transparent pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-12 sm:w-20 bg-gradient-to-l from-gray-50 to-transparent pointer-events-none" />
        </div>
      </div>
    </section>
  );
};

export default Testimonials;